import { render, staticRenderFns } from "./IyzicoModal.vue?vue&type=template&id=c9c98b18"
import script from "./IyzicoModal.vue?vue&type=script&lang=js"
export * from "./IyzicoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports